/**
 * @name results.controller:ApplyFastResult
 * @description
 * # ApplyFastResult
 * Listen for appropriate event and save fast results data from this event to own model.
 * Then this data will be shown in directive template.
 */
export default function ($rootScope, $scope, $element, $compile) {
    'ngInject';

    /**
     * Variables for directive
     *
     * @type {null|object} Model for directive
     * @type {string} Race id
     * @type {string} Name of event which directive should listen
     */
    $scope.fastResultsAvailable = false;
    $scope.raceId = $element.data('raceId');
    $scope.event = `setFastResults[${$scope.raceId}]`;
    const view = $element.contents();

    /**
     * Set copy properties from param object to $scope.raceInfo
     * @param {object} data Data from get request
     */
    $scope.setFastInfo = (data) => {
        $scope.fastInfo = [];
        $scope.fastResultsAvailable = true;
        if (data) {
            $scope.fastInfo = data;
            $element.append($compile(view)($scope));
            $scope.$digest();
        }
    };

    /**
     * Listen for appropriate event and call $scope.setFastInfo
     */
    $rootScope.$on($scope.event, (event, data) => {
        $scope.setFastInfo(data);
    });
}



// WEBPACK FOOTER //
// ./src/js/controllers/directiveApplyFastResult.js